export const reduxActionWindowEvent = '__gef_apm_redux__';
